class DeliveryOptionConstants {
  static readonly TIMER_OPTION: string = 'timer_settings';
  static readonly SHOW_FORM_TITLE: string = 'show_form_title';
  static readonly DISPLAY_TITLE: string = 'display_title';
  static readonly DISPLAY_SUBTITLE: string = 'display_subtitle';
  static readonly NOTEPAD = 'notepad';
  static readonly CALCULATOR = 'calculator';
  static readonly SHOW_PROGRESS_BAR = 'show_progress_bar';
  static readonly PROGRESS_BAR_COLOR = 'progress_bar_color';
  static readonly PAUSE_BUTTON = 'show_pause_button';
  static readonly EXIT_BUTTON = 'show_exit_button';
  static readonly FLAG_ITEM = 'flag_item';
  static readonly FOCUS_MODE = 'show_focus_mode';
  static readonly PROCTOR_RELEASE = 'wait_for_proctor_release';
  static readonly LOGOUT_SECTION = 'logout_after_section';
  static readonly STUDENT_NAME = 'show_student_name';
  static readonly QUESTION_NUMBER = 'show_question_number';
  static readonly ITEM_PROGRESS = 'show_item_progress';
  static readonly REVIEW_SCREEN = 'show_review_screen';
  static readonly FINAL_REVIEW_SCREEN = 'show_final_review_screen';
  static readonly WARN_ON_CHANGE = 'warn_on_change';
  static readonly SHOW_REDIRECT_URL = 'show_redirect_url';
  static readonly REDIRECT_URL = 'redirect_url';
  static readonly BLOCK_RETURN_TO_SECTION = 'block_return_to_section';
  static readonly CHOICE_MASKING = 'choice_masking';
  static readonly LINE_READER = 'line_reader';
  static readonly COLOR_SCHEME = 'color_scheme';
  static readonly ZOOM = 'zoom';
  static readonly FONT_SIZE = 'font_size';
  static readonly DICTIONARY = 'dictionary';
  static readonly HIGHLIGHTER = 'highlighter';
  static readonly TEXT_TO_SPEECH = 'text_to_speech';
}

export default DeliveryOptionConstants;
